import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {CpeResponseDTO} from "./dto/CpeResponseDTO";
import {AuthService} from "../../service/autenticacao/auth.service";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CpeService} from "../../service/cpe/cpe.service";
import {Router} from "@angular/router";
import {CpeAbstract} from "../../view/manifestos/cpe/abstract/CpeAbstract";
import {ModalComponent} from "../../view/manifestos/cpe/shared/modal/modal.component";
import {AssuntoDTO} from "../../entity/AssuntoDTO";
import {RequerimentoGeralComponent} from "../../view/manifestos/cpe/requerimento-geral/requerimento-geral.component";
import {
  DesarquivamentoAutosComponent
} from "../../view/manifestos/cpe/desarquivamento-autos/desarquivamento-autos.component";
import {OK_PROTOCOLO_MANIFESTACAO_CODIGO, OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO} from "../../tools/Mensagens";
import {PAGINA_HOME_USUARIO_INTERNO} from "../../tools/URL";
import {ResponseHandler} from "../../entity/ResponseHandlerDTO";

@Component({
  selector: 'app-cpe-operador',
  templateUrl: './cpe-operador.component.html',
  styleUrls: ['./cpe-operador.component.css']
})
export class CpeOperadorComponent extends CpeAbstract implements OnChanges {

  @Input('cpe') cpe: CpeResponseDTO;
  @Input() modoLeitura: boolean;
  @Input() assuntoSelecionado: AssuntoDTO;
  @Input() demandaRecebida: string;
  @Input() nomeManifestante: string;
  @Input() emailManifestante: string;
  tipoRequerimentoGeral = '1';

  @Output() formularioValidoChange = new EventEmitter<boolean>();
  @ViewChild(RequerimentoGeralComponent, {static: false}) requerimentoGeral: RequerimentoGeralComponent;
  @ViewChild(DesarquivamentoAutosComponent, {static: false}) desarquivamentoAutosComponent: DesarquivamentoAutosComponent;
  @ViewChild(ModalComponent, {static: false}) modalComponent!: ModalComponent;

  formulario = this.formBuilder.group({
    id: [null],
    tipoRequerimento: [this.tipoRequerimentoGeral, Validators.required],
    requerimentoGeral: this.formBuilder.group({}),
    desarquivamentoAutos: this.formBuilder.group({}),
    username: [this.authService.usuarioLogado.username, Validators.required],
    demandaRecebida: ['', Validators.required],
    nome: [this.authService.usuarioDTO.nome, Validators.required],
    email: [this.authService.usuarioDTO.email, Validators.required]
  });
  private manifestoEnum: any;


  constructor(public authService: AuthService,
              private formBuilder: FormBuilder,
              private service: CpeService,
              private router: Router) {
    super();
  }


  // Método auxiliar para debug - retorna lista de campos inválidos
  getInvalidControls(): string[] {
    const invalid = [];
    const controls = this.formulario.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(`${name}: ${JSON.stringify(controls[name].errors)}`);

        // Se for um FormGroup aninhado, verificar seus controles também
        if (controls[name] instanceof FormGroup) {
          const nestedControls = (controls[name] as FormGroup).controls;
          for (const nestedName in nestedControls) {
            if (nestedControls[nestedName].invalid) {
              invalid.push(`  ${name}.${nestedName}: ${JSON.stringify(nestedControls[nestedName].errors)}`);
            }
          }
        }

        // Se for um FormArray, verificar seus controles também
        if (controls[name] instanceof FormArray) {
          const arrayControls = (controls[name] as FormArray).controls;
          arrayControls.forEach((control, index) => {
            if (control.invalid) {
              invalid.push(`  ${name}[${index}]: ${JSON.stringify(control.errors)}`);

              if (control instanceof FormGroup) {
                const nestedControls = control.controls;
                for (const nestedName in nestedControls) {
                  if (nestedControls[nestedName].invalid) {
                    invalid.push(`    ${name}[${index}].${nestedName}: ${JSON.stringify(nestedControls[nestedName].errors)}`);
                  }
                }
              }
            }
          });
        }
      }
    }

    return invalid;
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assuntoSelecionado'] && changes['assuntoSelecionado'].currentValue) {
      this.mostrarRequerimentoGeral();
    }
    if (changes['cpe'] && this.cpe) {
      this.formulario.patchValue({
        id: this.cpe.id ? this.cpe.id : null
      });
    }

    this.adicionaNoFormularioDadosOperador(changes);
  }

  onSubmit(enviar: boolean, manifesto: { id: number; ordem: number, codigo: string }) {
    const formularioValido = this.validarFormulario();
    if (formularioValido) {
      if(this.formulario.get('id').value == null){
        this.salvar(enviar, manifesto);
      }else{
        this.atualizar(enviar, manifesto);
      }
    }
  }


  private salvar(enviar: boolean, manifesto: { id: number; ordem: number; codigo: string }) {
    this.service.salvar(this.formulario.value, enviar).subscribe((retorno: ResponseHandler) => {
      this.acaoRetorno(retorno, manifesto, enviar);
    });
  }

  private atualizar(enviar: boolean, manifesto: { id: number; ordem: number; codigo: string }) {
    this.service.atualizar(this.formulario.value, this.formulario.get('id').value, enviar).subscribe((retorno: ResponseHandler) => {
      this.acaoRetorno(retorno, manifesto, enviar);
    });
  }

  private acaoRetorno(retorno: ResponseHandler, manifesto: {
    id: number;
    ordem: number;
    codigo: string
  }, enviar: boolean) {
    if (retorno.data) {
      if (enviar) {
        alert(OK_PROTOCOLO_MANIFESTACAO_CODIGO(manifesto.codigo + retorno.data.id));
      } else {
        alert(OK_PROTOCOLO_RASCUNHO_MANIFESTACAO_CODIGO(manifesto.codigo + retorno.data.id));
      }
      this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
    }
  }

  private mostrarRequerimentoGeral() {
    if (this.assuntoSelecionado.value == 'requerimento_geral') {
      super.mostrarRequerimentogeral = true;
      super.mostrarDesaquirvamentoAutos = false;
      this.formulario.get('tipoRequerimento').setValue("1");
    } else {
      super.mostrarDesaquirvamentoAutos = true;
      super.mostrarRequerimentogeral = false;
      this.formulario.get('tipoRequerimento').setValue("2");
    }
  }

  private adicionaNoFormularioDadosOperador(changes: SimpleChanges) {
    if (changes['nomeManifestante'] && changes['nomeManifestante'].currentValue) {
      this.formulario.get('nome').setValue(this.nomeManifestante);
    }
    if (changes['emailManifestante'] && changes['emailManifestante'].currentValue) {
      this.formulario.get('email').setValue(this.emailManifestante);
    }
    if (changes['demandaRecebida'] && changes['demandaRecebida'].currentValue) {
      this.formulario.get('demandaRecebida').setValue(this.demandaRecebida);
    }
  }

  private validarFormulario(): boolean {
    this.gerarAlertaUsuarioAutenticado();

    if (this.formulario.get('tipoRequerimento').value === this.tipoRequerimentoGeral) {
      this.validarFormularioRequerimentoGeral();
    } else {
      this.validarFormularioDesarquivamentoAutos();
    }
    this.gerarAlertaFormularioStatusInvalid();
    return this.formulario.valid;
  }

  private validarFormularioRequerimentoGeral() {
    if (this.requerimentoGeral) {
      this.requerimentoGeral.validarFormulario();
    }
  }

  private validarFormularioDesarquivamentoAutos() {
    if (this.desarquivamentoAutosComponent) {
      this.desarquivamentoAutosComponent.validarFormulario();
    }
  }

  private gerarAlertaUsuarioAutenticado() {
    if (!this.formulario.get('nome').valid) {
      alert('Não foi possível indentificar o nome do usuário autenticado, favor sair e logar novamente');
    }
    if (!this.formulario.get('email').valid) {
      alert('Não foi possível indentificar o e-mail do usuário autenticado, favor sair e logar novamente');
    }
  }

  private gerarAlertaFormularioStatusInvalid() {
    if (!this.formulario.valid) {
      alert('O formulário não foi validado em todos os critérios de aceitação');
    }
  }


}
